import isEqual from 'lodash/isEqual.js';
import { createSelectorCreator, defaultMemoize } from 'reselect';
/**
 * Create a "selector creator" that uses `lodash.isEqual` instead of `===`
 */
export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
//# sourceMappingURL=helpers.js.map